module.exports = __webpack_public_path__ + "assets/4cb18e9cb63e2924a185952e5cd832f3.mp3";